// TODO - remove lint disable when editing this file
/* eslint-disable */
import intl from 'react-intl-universal'
import { ACTION_SEND_TO_PRINT, sendToPrintResolved } from '~/redux/appReducer'
import { Observable } from 'rxjs'
import { successAction, errorAction } from '~/redux/commonActions'
import { getSettings } from '~/redux/settingsReducer'
import url from 'url'
import { publishUnpublishedImages } from '~/modules/services/story/imagePublishing'
import CONSTANTS from '~/constants'

export default (action$, store, { serviceResolver }) =>
  action$
    .ofType(ACTION_SEND_TO_PRINT)
    .mergeMap((action) => {
      const storyService = serviceResolver('storyService')
      return Observable.from(storyService.getStory())
        .map((story) => {
          return {
            ...story,
            print_url: getSettings(store.getState())['sendToPrintURL'] || '',
            ifx_send_to_print:
              getSettings(store.getState())['useIFXSendToPrint'] || '',
          }
        })
        .mergeMap((story) => {
          const { _id: storyId, print_url: printUrl = '', ifx_send_to_print } =
            story || {}
          if (!storyId) {
            throw new Error(intl.get('epics.sendToPrintEpic.errors.noStoryId'))
          }
          if (!ifx_send_to_print && !printUrl) {
            throw new Error(intl.get('epics.sendToPrintEpic.errors.noPrintUrl'))
          }

          return Observable.fromPromise(
            publishUnpublishedImages(story).then((imagePublishResponse) => ({
              imagePublishResponse,
              story,
            }))
          )
        })
        .mergeMap(({ imagePublishResponse, story }) => {
          const {
            _id: storyId,
            canonical_url: canonicalUrl = '',
            canonical_website: canonicalWebsite = '',
            owner,
            print_url: printUrl = '',
            revision: { revision_id: revisionId = '' } = {},
            ifx_send_to_print,
          } = story || {}

          let sendToPrintPath
          let sentToPrintBody = null
          let orgId = owner?.id.split('.')[1] || owner?.id

          if (ifx_send_to_print) {
            sendToPrintPath = `${CONSTANTS.TRIDENT_ROUTE_IFX_INVOKE_API}/${CONSTANTS.IFX_COMPOSER_SEND_TO_PRINT_EVENT}`
            sentToPrintBody = {
              story_id: storyId,
              revision_id: revisionId || '',
              canonical_url: canonicalUrl || '',
              date: new Date().toString(),
              canonical_website: canonicalWebsite || '',
            }
          } else {
            sendToPrintPath = url.format({
              pathname: `${CONSTANTS.TRIDENT_ROUTE_COMPOSER_API}/v1/stp`,
              query: {
                story_id: storyId,
                revision_id: revisionId || '',
                canonical_url: canonicalUrl || '',
                print_url: printUrl,
              },
            })
          }
          return Observable.fromPromise(
            fetch(sendToPrintPath, {
              method: 'POST',
              credentials: 'same-origin',
              header: 'Content-Type: application/json',
              body: JSON.stringify(sentToPrintBody),
            })
          ).mergeMap((response) => {
            if (!response.ok) {
              return Observable.fromPromise(response.json()).mergeMap(
                (errorResponse) => {
                  if (errorResponse) {
                    let errorKey
                    if (
                      errorResponse.errorCode === 'ResourceNotFoundException'
                    ) {
                      errorKey = 'integrationUnsubscribed'
                    } else if (ifx_send_to_print) {
                      errorKey = errorResponse.errorMessage
                    } else {
                      errorKey = 'sendToPrintFailed'
                    }
                    return Observable.of(
                      sendToPrintResolved(),
                      errorAction(
                        new Error(
                          intl.get('epics.sendToPrintEpic.failure', {
                            msg: intl.get(
                              `epics.sendToPrintEpic.errors.${errorKey}`
                            ),
                          })
                        )
                      )
                    )
                  } else {
                    return Observable.of(
                      sendToPrintResolved(),
                      errorAction(
                        new Error(
                          intl.get('epics.sendToPrintEpic.failure', {
                            msg: intl.get(
                              `epics.sendToPrintEpic.errors.${errorResponse.errorKey}`
                            ),
                          })
                        )
                      )
                    )
                  }
                }
              )
            }

            if (imagePublishResponse.unpublishedImagesFound) {
              if (!imagePublishResponse.hasPPPermission) {
                return Observable.of(
                  sendToPrintResolved(),
                  successAction(intl.get('epics.sendToPrintEpic.success')),
                  errorAction(new Error(`${imagePublishResponse.message}`))
                )
              } else {
                return Observable.of(
                  sendToPrintResolved(),
                  successAction(intl.get('epics.sendToPrintEpic.success')),
                  successAction(`${imagePublishResponse.message}`)
                )
              }
            }
            return Observable.of(
              sendToPrintResolved(),
              successAction(
                ifx_send_to_print
                  ? intl.get('epics.sendToPrintEpic.ifxSuccess')
                  : intl.get('epics.sendToPrintEpic.success')
              )
            )
          })
        })
        .catch((error) => {
          return Observable.of(sendToPrintResolved(), errorAction(error))
        })
    })
    .filter((action) => !!action)
